import { useQuery } from 'react-query';
import api from "./Api";

export const usePlanQuery = () => { 
	return useQuery(['plans'], async () => {
		let res = await api.get('/plans');
		return res.data;
	}, { staleTime: Infinity, cacheTime: 600000 });
}